export const getters = {
  projectTypeOfPur(state) {
    return state.projectTypeOfPur;
  },
  purchaseType(state) {
    return state.purchaseType;
  },
  purchaseProcessList (state) {
    return state.purchaseProcessList;
  },
  goodsType (state) {
    return state.goodsType;
  }
};
